export default __webpack_public_path__ + "static/media/delete.52c40c49.svg";